(() => {
  const selector = 'iframe[data-kz-youtube-src]';
  const observed = new WeakSet();
  let observer;

  function loadPlayer(frame) {
    const src = frame.getAttribute('data-kz-youtube-src');
    if (!src) return;
    observer?.unobserve(frame);
    frame.setAttribute('loading', 'eager');
    frame.setAttribute('src', src);
    frame.removeAttribute('data-kz-youtube-src');
  }

  function initialize(root = document) {
    const frames = root.querySelectorAll(selector);
    if (!frames.length) return;
    if (!('IntersectionObserver' in window)) {
      frames.forEach(loadPlayer);
      return;
    }
    observer ||= new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) loadPlayer(entry.target);
      });
    }, { rootMargin: '300px 0px', threshold: 0 });
    frames.forEach((frame) => {
      if (observed.has(frame)) return;
      observed.add(frame);
      observer.observe(frame);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('focusin', (event) => {
    if (event.target.matches?.(selector)) loadPlayer(event.target);
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(selector).forEach((frame) => {
      observer?.unobserve(frame);
      observed.delete(frame);
    });
  });
})();
